import { Component } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { PetService } from '@app/services/pet.service';
import { ContentService } from 'app-classic/services/content.service';
import { AddPetComponent as NewAddPetComponent } from '../../../../app/components/booking-steps/add-pet/add-pet.component';

@Component({
    selector: 'app-add-pet',
    templateUrl: './add-pet.component.html',
    styleUrls: ['./add-pet.component.scss'],
    standalone: false,
})
export class AddPetComponent extends NewAddPetComponent {
    constructor(
        private bottomSheetAddPet: MatBottomSheet,
        private _contentService: ContentService,
        private _petService: PetService
    ) {
        super(_contentService, _petService);
    }

    public closeBottomSheet() {
        this.bottomSheetAddPet.dismiss();
    }
}
